import { render, staticRenderFns } from "./otherUrlView.vue?vue&type=template&id=483654fc&scoped=true"
var script = {}
import style0 from "./otherUrlView.vue?vue&type=style&index=0&id=483654fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483654fc",
  null
  
)

export default component.exports